import React from 'react';

import { Button, utils } from '@ergeon/core-components';
import { PhoneIcon } from '@ergeon/icons/hero/micro';

import { DEFAULT_PHONE } from './constants';
import { PhoneLinkProps } from './types';

const PhoneLink: React.FC<PhoneLinkProps> = ({ className, phoneNumber = DEFAULT_PHONE }) => {
  const { link, display } = utils.formatPhoneNumber(phoneNumber);

  return (
    <Button
      asAnchor
      className={className}
      data-track-call="true"
      flavor="regular"
      href={link}
      taste="boundless">
      <PhoneIcon aria-hidden="true" className="size-4 text-orange-600 dark:text-orange-400" />
      {display}
    </Button>
  );
};

export default PhoneLink;
